<template>
<div class="text-center" style="position: relative;">
    <div class="meter-container">
        <img
            :src="backgroundAssetUrl"
            class="image-center"
            style="width: 65%; display:inline-block; vertical-align: middle;">
        <img
            :src="arrowAssetUrl"
            :style="style"
            class="arrow-meters">
    </div>
    <div>{{ title }}: {{ value }}</div>


</div>
</template>

<style>

    .meter-container {
        position: relative;
    }
    .image-center {
        display: block;
        margin: 0 auto;
        z-index: 1;
        width: 250px;
    }
    .arrow-meters {
        position: absolute;
        height: 60%;
        z-index: 3;
        bottom: 0;
        left: 50%;
        top: unset;
        transform-origin: 0 94%;
        -webkit-transform-origin: 0 94%;
        -webkit-backface-visibility: hidden;
        margin: 0;
        transform: translateX(-50%);
    }
</style>

<script>
export default {
    props: {
        backgroundAssetUrl: {
            type: String
        },
        arrowAssetUrl: {
            type: String
        },
        arrowDegree: {
            type: Number,
            default: 0
        },
        value: {
            type: Number
        },
        title: {
            type: String
        },
        shown: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        style() {
            return 'transform: rotate(' + this.arrowDegree + 'deg) translateX(-50%);'
        }
    }
}
</script>

